import { render, staticRenderFns } from "./JoinEvent20.vue?vue&type=template&id=16009c33&scoped=true&"
import script from "./JoinEvent20.vue?vue&type=script&lang=js&"
export * from "./JoinEvent20.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16009c33",
  null
  
)

export default component.exports